import { Segmented } from 'antd';
import { useState } from 'react';
import { MetricList } from './MetricList';
import { BaselineData } from './BaselineData';
import Reminder from './Reminder';
import useTranslation from 'next-translate/useTranslation';

function IdeaMetrics() {
  const { t } = useTranslation('common');
  const [activeView, setActiveView] = useState<string>('metrics-list');

  const renderContent = () => {
    switch (activeView) {
      case 'metrics-list':
        return <MetricList />;
      case 'baseline-data':
        return <BaselineData />;
      case 'reminder':
        return <Reminder />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-4">
      <Segmented
        rootClassName="overflow-x-auto"
        options={[
          { value: 'metrics-list', label: t('metrics_list') },
          { value: 'baseline-data', label: t('baseline_data') },
          { value: 'reminder', label: t('reminder') },
        ]}
        value={activeView}
        onChange={(value) => setActiveView(value.toString())}
      />

      {renderContent()}
    </div>
  );
}

export default IdeaMetrics;
